// @ts-nocheck
import styled from 'styled-components';
import colors from '../../../../styles/colors';

const SpaceButton = styled.div`
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

const ContainerButton = styled.div`
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border: 2px solid ${props => props.borderColor};
    background-color: ${props => props.mainBgColor};
    color: white;
    border-radius: 10px;

    &:hover {
        background-color: ${props => props.borderColor};
    }
`;

const BoxAvatar = styled.div`
    width: 25%;
    height: 90%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 5px;

    & img.avatar-wrestler {
        width: 100%;
        height: 90%;
        object-fit: cover;
        object-position: top;
    }
`;

const BoxInfo = styled.div`
    width: 75%;
    height: 95%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    /* border: 1px solid white; */
    border-radius: 10px;

    & p {
        margin: 0;
        padding: 0;
        font-size: 10px;
        font-weight: 800;
        color: white;
        text-align: center;
        width: 100%;
        text-transform: uppercase;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;

function RenderButtonChangePageStats(
    {
        title, 
        wrestler, 
        onClick, 
        mainBgColor = colors.bgColorBlack2, 
        borderColor = colors.bgColorBordeaux,
    }
) {

    return (
        <SpaceButton className='space-button'>
            <ContainerButton className='container-button' onClick={onClick} mainBgColor={mainBgColor} borderColor={borderColor}>
                <BoxAvatar className='box-avatar'>
                    <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} className='avatar-wrestler' />
                </BoxAvatar>
                <BoxInfo className='box-info'>
                    <p>{title}</p>
                </BoxInfo>
            </ContainerButton>
        </SpaceButton>
    )
}

export default RenderButtonChangePageStats;